import { fromJS, List, Record } from 'immutable';
import { TaskItem } from './submodels/task-item.model';
import { TaskHeader } from './submodels/task-header.model';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';

export const TASKS_SCHEMA = Object.freeze({
  HAS_SHOWN_CONGRATULATIONS: false,
  HEADER: TaskHeader,
  ITEMS: List<TaskItem>(),
});
export const RECORD = generateSchema(TASKS_SCHEMA);
export const KEYS: any = generateKeys(TASKS_SCHEMA);

export class Task extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.HEADER,
        value: new TaskHeader(this.header),
      },
      {
        key: KEYS.ITEMS,
        value: props.get(KEYS.ITEMS)
          ? this.items.map((item) => new TaskItem(item))
          : List<TaskItem>([]),
      },
    ]);

    return selfModel as Task;
  }

  get hasShownCongratulations(): boolean {
    return this.get(KEYS.HAS_SHOWN_CONGRATULATIONS);
  }

  get header(): TaskHeader {
    return this.get(KEYS.HEADER);
  }

  get items(): List<TaskItem> {
    return this.get(KEYS.ITEMS);
  }
}
